//region 1. Platform Libraries
import { assert } from 'chai';
import winston from 'winston';
//endregion

//region 2. Project Libraries
import LogLevel from './LogLevel';
//endregion

//region T. Tests
describe('LogLevel', () => {
    it('should detect membership', () => {
        let inputString = 'ERROR';
        assert.equal(true, !!LogLevel[inputString]);
        inputString = 'WARN';
        assert.equal(true, !!LogLevel[inputString]);
        inputString = 'INFO';
        assert.equal(true, !!LogLevel[inputString]);
        inputString = 'DEBUG';
        assert.equal(true, !!LogLevel[inputString]);
    });

    it('should detect non-membership', () => {
        const inputString = 'TRACE';
        assert.equal(true, !LogLevel[inputString]);
        assert.equal(true, !LogLevel[undefined]);
    });

    it('should get level names', () => {
        assert.equal('ERROR', LogLevel.ERROR.name);
        assert.equal('WARN', LogLevel.WARN.name);
        assert.equal('INFO', LogLevel.INFO.name);
        assert.equal('DEBUG', LogLevel.DEBUG.name);
    });

    it('should get levels', () => {
        assert.equal(winston.config.npm.levels.error, LogLevel.ERROR.level);
        assert.equal(winston.config.npm.levels.warn, LogLevel.WARN.level);
        assert.equal(winston.config.npm.levels.info, LogLevel.INFO.level);
        assert.equal(winston.config.npm.levels.debug, LogLevel.DEBUG.level);
    });
});
//endregion
